import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export function IngestBanner() {
  const [s, setS] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/ingest-status").then((r) => alive && setS(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  if (!s?.active) return null;
  const n = (v) => Number(v || 0).toLocaleString("en-IN");
  if (s.kind === "rebuild_analytics") {
    return (
      <div className="bg-amber-50 border-b border-amber-200 px-8 py-2 text-xs text-amber-900 flex items-center gap-2" data-testid="ingest-banner">
        <Loader2 className="w-3.5 h-3.5 animate-spin" /> Analytics rebuild in progress: {s.message || "working…"}
      </div>
    );
  }
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-8 py-2 text-xs text-amber-900 flex items-center gap-2" data-testid="ingest-banner">
      <Loader2 className="w-3.5 h-3.5 animate-spin" />
      Historic data load in progress: figures update as data arrives ({n(s.bills_loaded)}{s.bills_total ? ` of ${n(s.bills_total)}` : ""} bills loaded)
    </div>
  );
}
